import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const applyClipboardValues = async (values: string[]) => {
  const crud = CrudStore.get(CrudStoreItemPartner360.JBPComposedReportClipBoard)
  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        value: values,
        operator: Operator.EQUAL,
        field: 'Ids',
      },
    ],
  })
  const res = await crud.fetch({ force: true })
  crud.removeQueries()
  crud.cleanCache()
  const item = res.items[0]

  if (!item) {
    return { foundPartners: [], unmatched: values }
  }
  const foundPartners = item.Result ? JSON.parse(item.Result) : []
  const unmatched: string[] = item.Unmatched
    ? JSON.parse(item.Unmatched).map((el: Record<string, string>) => el.SourceID)
    : []
  return { foundPartners, unmatched }
}
